// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/hero_image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_LOGIN */
/* CRIO_SOLUTION_END_MODULE_LOGIN */
.search {
  min-width: 24rem;
  position: relative;
  left: 4rem;
}

.hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-grid {
  width: 100%;
}

.hero-heading {
  color: #fff;
  font-size: 1.5rem;
  width: 80%;
  position: relative;
  left: 1rem;
}

.hero-highlight {
  color: #212121;
  font-weight: 700;
  background: #ffb825;
  border-radius: 5px;
  padding: 0.2rem;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50vh;
}

.search-mobile {
  display: block !important;
}

.search-desktop {
  display: none !important;
}

@media screen and (min-width: 768px) {
  .hero {
    justify-content: flex-end;
    height: 20rem;
    padding-right: 8rem;
  }
  .hero-heading {
    position: static;
    font-size: 3rem;
    width: 50%;
  }
  .search-mobile {
    display: none !important;
  }
  .search-desktop {
    display: block !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Products.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yDAAiD;EACjD,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_LOGIN */\n/* CRIO_SOLUTION_END_MODULE_LOGIN */\n.search {\n  min-width: 24rem;\n  position: relative;\n  left: 4rem;\n}\n\n.hero {\n  background-image: url(\"../assets/hero_image.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 10rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-grid {\n  width: 100%;\n}\n\n.hero-heading {\n  color: #fff;\n  font-size: 1.5rem;\n  width: 80%;\n  position: relative;\n  left: 1rem;\n}\n\n.hero-highlight {\n  color: #212121;\n  font-weight: 700;\n  background: #ffb825;\n  border-radius: 5px;\n  padding: 0.2rem;\n}\n\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50vh;\n}\n\n.search-mobile {\n  display: block !important;\n}\n\n.search-desktop {\n  display: none !important;\n}\n\n@media screen and (min-width: 768px) {\n  .hero {\n    justify-content: flex-end;\n    height: 20rem;\n    padding-right: 8rem;\n  }\n  .hero-heading {\n    position: static;\n    font-size: 3rem;\n    width: 50%;\n  }\n  .search-mobile {\n    display: none !important;\n  }\n  .search-desktop {\n    display: block !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
